import './BrandLockup.css';

/** Bütün uygulama kabuklarında kullanılan tek WONDEON HUB marka kilidi. */
export function BrandLockup({ className = '' }: { className?: string }) {
  return (
    <span className={`brand-lockup ${className}`.trim()} role="img" aria-label="Wondeon Hub">
      <img className="brand-lockup__logo" src="/covers/wondeon-logo.svg" alt="" aria-hidden="true" />
      <span className="brand-lockup__hub" aria-hidden="true">HUB</span>
    </span>
  );
}
